import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './EmployerSponsoredTile.css';

import { OrgInformationalBenefit } from 'theSource/queries';

type SingleEmployerTileProps = {
  benefit: OrgInformationalBenefit;
  isCenter?: boolean;
};

export function EmployerSingleSponsoredTile({
  benefit,
  isCenter = false,
}: SingleEmployerTileProps) {
  const navigate = useNavigate();
  const { t } = useTranslation('pages.home');

  const bodyTextRef = useRef<HTMLParagraphElement>(null);

  function stripHtmlTags(html: string) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  const missingLogo =
    benefit.carrier_logo_url === '/images/plan_content/blanklogo_white.png';

  return (
    <div className="employer-tile-wrapper" data-testid="carousel-employer-tile">
      {missingLogo ? (
        <div className="logo-fallback-container" tabIndex={isCenter ? 0 : -1}>
          <span
            className={`logo-fallback-text ${isCenter ? 'center' : ''}`}
            onClick={() => navigate(`/benefits/${benefit.benefit_lookup_code}`)}
            style={{ cursor: 'pointer' }}
          >
            {benefit.carrier_name}
          </span>
        </div>
      ) : (
        <button
          className="benefit-tile"
          onClick={() => navigate(`/benefits/${benefit.benefit_lookup_code}`)}
          tabIndex={isCenter ? 0 : -1}
        >
          <div className="logo-wrapper">
            <img
              className="logo-img"
              src={benefit.carrier_logo_url}
              alt={`${benefit.carrier_name}-employer-sponsored-logo`}
            />
          </div>
        </button>
      )}

      {isCenter && (
        <>
          <h3 className="headline">{benefit.name}</h3>
          <p className="body-text" ref={bodyTextRef}>
            {stripHtmlTags(benefit.description)}
          </p>

          <ps-button
            id={`learn-more-${benefit.id}`}
            label={t('accountsOtherBenefits.learnMore')}
            level="secondary"
            onClick={() => navigate(`/benefits/${benefit.benefit_lookup_code}`)}
            tabIndex={0}
            aria-label={`${benefit.name} - ${t('accountsOtherBenefits.learnMore')}`}
          />
        </>
      )}
    </div>
  );
}
